(function(window, undefined) {
    if (window.mg === undefined)
        window.mg = {};

    const _ = window.mg;

    class Converter {
        padZeroes(number) {
            return number < 10 ? '0' + number : '' + number;
        }

        dateTimeToText(date, format = 'YYYYMMDD[T]HHmmss') {
            return moment(date).format(format);
        }

        dateTimeToTimeText(date) {
            return moment(date).format('HH[' + _.dateTimeFormat.TimeSeparator + ']mm');
        }

        dateToText(date, includeHourMinute = true) {
            return moment(date).format('YYYYMMDD' + (includeHourMinute ? '[T000000]' : ''));
        }

        textToDate(value) {
            return moment(value, 'YYYYMMDD').toDate();
        }

        textToDateTime(value) {
            return moment(value, 'YYYYMMDD[T]HHmmss').toDate();
        }

        toNumeric(value, failValue) {
            return (isNaN(value) || value == '') ? (isNaN(failValue) || failValue == '') ? Number.MIN_VALUE : parseInt(failValue) : parseInt(value);
        }

        toDecimal(value) {
            return parseFloat(value.replace(',', '.'));
        }

        toHcp(value) {
            let hcp = this.toDecimal(value);

            if (value.indexOf('+') === 0)
                hcp = -hcp;

            return hcp;
        }

        hcpToText(value, culture = _.culture) {
            let tmpHcp = (typeof value === 'number') ? value : this.toHcp(value);
            let digits = tmpHcp >= 37 ? 0 : 1;

            if (tmpHcp < 0)
                return '+' + Math.abs(tmpHcp).toLocaleString(culture, { minimumFractionDigits: digits, maximumFractionDigits: digits });

            if (tmpHcp > 36 && /(,|\.)[1-9]/ig.test(tmpHcp.toFixed(2)))
                digits = 1;

            return tmpHcp.toLocaleString(culture, { minimumFractionDigits: digits, maximumFractionDigits: digits });
        }

        formatDecimal(value, digits = 1, forceDigits = false, culture = _.culture) {
            if (value === '')
                return '';

            let tmpDec = (typeof value === 'number') ? value : this.toDecimal(value);

            if (forceDigits !== true && tmpDec % 1 === 0)
                return tmpDec.toLocaleString(culture, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });

            return tmpDec.toLocaleString(culture, {
                minimumFractionDigits: digits,
                maximumFractionDigits: digits
            });
        }

        formatAmount(value, forceDecimals = false, includeCurrency = false) {
            // Returns a number formatted with 2 digits (depending on the forceDecimal value)
            return this.formatDecimal(value, 2, forceDecimals) + (includeCurrency ? ' kr' : '');
        }

        formatDate(value, includeYear) { // Expects a moment instance
            return value.format('DD MMM' + (includeYear ? ' YY' : '')); // TODO - Should dates always be formatted like this?
        }

        formatTime(value) { // Expects a moment instance
            return value.format('HH' + _.dateTimeFormat.TimeSeparator + 'mm');
        }

        timeUnitToMinutes(minutes, unit) {
            switch (unit) {
                case 0: return minutes;        // minutes
                case 1: return minutes * 60;   // hours
                case 2: return minutes * 1440; // days
            }
        }
    }

    _.cc = new Converter();
})(window);
